// Cart main Alpine component — externalized from sections/main-cart-items.liquid (GFTY-4799-7).
// Liquid-dependent values are read from window.__cartConfig / window.__cartItemsWithMetafields,
// emitted inline in the section. Behavior is identical to the previous inline component.
  function getData() {
    return {
      cartDataReady: true,  // Add this new property
      isB2B: !!window.__isB2B,
      // AB Tasty double-dipping experiment variant. Read reactively so the price_on_giftory
      // strikethroughs re-render if AB Tasty sets window.doubleDippingVariant after init (see init()).
      doubleDippingVariant: window.doubleDippingVariant === 'treatment' ? 'treatment' : null,
      async init() {
        if (!Alpine.store('cartStore')) {
          Alpine.store('cartStore', {
            cart: {
              items: [], // Initialize items as an empty array
              total_price: 0,
              item_count: 0,
              items_subtotal_price: 0,
              original_total_price: 0,
              total_discount: 0,
            },
            isPageLoading: true,
            isCodeApplied: false,
            ddPriceSettling: false, // GFTY-4391: mask the line price cell while the dd transform settles
            discountsData: null,
            variantProductId: null,
            allCartItems: [],
            isGiftCardInCart: false,
          });
          Alpine.store('cartStore').fetchCart = this.fetchCart.bind(this);
        }
        // AB Tasty sets window.doubleDippingVariant asynchronously. Poll up to 10s; assigning it
        // reactively makes the price_on_giftory strikethroughs re-render once the variant resolves.
        if (this.doubleDippingVariant !== 'treatment') {
          const self = this;
          let ddElapsed = 0;
          const ddPoll = setInterval(() => {
            ddElapsed += 100;
            if (window.doubleDippingVariant === 'treatment') {
              self.doubleDippingVariant = 'treatment';
              clearInterval(ddPoll);
            } else if (ddElapsed >= 10000) {
              clearInterval(ddPoll);
            }
          }, 100);
        }
        // Function that sets up watches and initializes anything required
        this.$watch('formData.email', (value) => {
          this.checkEmail();
          // write the email onto the cart's buyerIdentity as the shopper types,
          // not at checkout time. Keeps the Storefront call off the critical path entirely,
          // gives it seconds of slack to retry, and — because the cart now persists all the
          // way to checkout — stops a failed write leaving a STALE email prefilled.
          this.queueCheckoutEmailSync();
        });
        this.$watch('formData.checkbox', (value) => this.checkCheckbox());
        this.$watch('formData.buyFor', (value) => {
          this.checkBuyForOption();
          if (value === 'Other' && this.oneRuleEngineActivated()) {
            this.formData.send_by = 'Email';
          }
          this.queueGiftBoxSync();
        });
        this.$watch('formData.selectedYear', (value) => this.validateDates());
        this.$watch('formData.selectedMonth', (value) => this.validateDates());
        this.$watch('formData.selectedDay', (value) => this.validateDates());
        this.$watch('formData.emailTo', (value) => this.checkEmailToOption());
        this.$watch('formData.send_by', (value) => {
          this.checkSentByOption();
          // reconcile the gift box the moment the shopper picks Post/Email
          // instead of at submit. add.js was the single most expensive call on the checkout
          // path (~690ms); doing it here takes it off that path entirely.
          this.queueGiftBoxSync();
        });
        await this.fetchSingleProductData();
        // GFTY-4391: mask the line PRICE cell for the treatment arm until the dd cart
        // transform has settled (done at the end of init). The cart itself renders
        // immediately (gated on isPageLoading); only the price shows a shimmer, so the
        // shopper never sees the off-everyday→off-POG price flash — and the cart isn't
        // blocked waiting on the ~seconds-long transform re-eval. Control/unset arms skip
        // it and show the price right away.
        if (window.doubleDippingVariant === 'treatment') {
          Alpine.store('cartStore').ddPriceSettling = true;
        }
        await this.fetchCart();

        // Set the email from session storage
        this.formData.email = sessionStorage.getItem('userCartEmail') || '';
        this.$watch('cart', (value) => {
          const cartSubtotalNum = Number((value.original_total_price / 100).toFixed(2));
          const toNumber = Number(this.minPhysicalPackageTotalAllowed).toFixed(2);
          const physicalPackageTotalAllowed = Number(parseFloat(toNumber).toFixed(2));
          if (this.showPackageOption && this.oneRuleEngineActivated() && this.formData.buyFor === 'Other') {
            this.formData.send_by = 'Email';
            const cartState = JSON.parse(sessionStorage.getItem('cartState'));
            sessionStorage.setItem('cartState', JSON.stringify({ ...cartState, attributes: { ...cartState?.attributes, send_by: 'Email' } }));
          }
        });

        if (this.isPackagedProduct && this.giftBoxAvailable() && !this.digitalOnlyRule()) {
          this.formData.buyFor = 'Other';
          this.formData.send_by = 'Post';
          if (this.formData.buyFor === 'Other') {
            this.formData.send_by = 'Post';
          }
          this.isValid = true;
        }

        await this.loadSavedCartState();
        // previously this stripped the gift box on EVERY cart load, so a
        // shopper returning from checkout with Post still selected had to pay for the re-add
        // when they clicked checkout again. Reconcile to the choice we just restored instead.
        // Computed from the saved state rather than waiting on the watchers above, whose
        // Alpine callbacks have not necessarily flushed yet. The rule engine forces e-voucher,
        // so it can never want a box.
        await this.syncGiftBox(!this.oneRuleEngineActivated() && this.wantsGiftBox());
        // init's own writes to buyFor/send_by above queued a reconcile through the watchers;
        // the line above just did it, so drop the duplicate rather than spend another read.
        clearTimeout(this._giftBoxTimer);
        this.$watch('formData', (value) => {
          console.log('Form Data changed:', value);
          this.saveCartState();
        }, { deep: true });

        // GFTY-4391: cart is interactive now — settle the dd price in the background.
        // Write the coupon-bridge attribute, let the cart transform rebase off POG,
        // re-fetch the transformed prices, then reveal the price cell. Treatment arm
        // only; a no-op (just unmask) when no code is applied.
        if (window.doubleDippingVariant === 'treatment') {
          try {
            // Reconcile _dd_coupon from the CURRENT cart on every load — not only when a
            // code is applied. A stale _dd_coupon (a code removed at checkout, or a
            // persisted attribute) otherwise keeps the transform neutralizing a flash line,
            // so the flash function then discounts the inflated base — Red Lobster showed
            // ~$44.44 → $34.44 with NO code applied. buildMap excludes flash-only lines, so
            // with no code this writes an empty map and the line returns to its flash price.
            // sync() no-ops (no write, no returned response) when the attribute already
            // matches, so an already-accurate cart skips the extra transform re-eval + refetch.
            if (window.ddCouponSync) {
              const wrote = await window.ddCouponSync();
              if (wrote) await this.fetchCart(false);
            }
          } catch (e) {}
          Alpine.store('cartStore').ddPriceSettling = false;
        }

        const buyforHidden = document.getElementById('buying-for-hidden');
      },
      onEmailGiftForChange(e) {
        this.formData.emailGiftFor = e.target.value;
        this.validations.emailGiftFor.required = false
      },
      formData: {
        email: "",
        phone: "",
        checkbox: true,
        buyFor: "",
        emailTo: "",
        emailGiftFor: "",
        dateType: 'immediately',
        selectedYear: "",
        selectedMonth: "",
        selectedDay: "",
        selectedTimeSlot: "",
        selectedAmPm: "",
        selectedTimeZone: "",
        customMessage: "",
        send_by: "",
        send_by_ab: "",
      },
      validations: {
        email: {
          required: false,
        },
        phone: {
          required: false,
        },
        checkbox: {
          required: false,
        },
        buyFor: {
          required: false,
        },
        emailTo: {
          required: false,
        },
        selectedYear: {
          required: false,
        },
        selectedMonth: {
          required: false,
        },
        selectedDay: {
          required: false,
        },
        selectedTimeSlot: {
          required: false,
        },
        selectedAmPm: {
          required: false,
        },
        selectedTimeZone: {
          required: false,
        },
        emailGiftFor: {
          required: false,
        },
        date: {
          required: false,
        },
        sendBy: {
          required: false,
        },
      },
      isOpen: false,
      currentSlide: 0,
      scrollPosition: 0,
      modaleType: null,
      beforeAnyDiscount: 0,
      productDiscounts: 0,
      isItemsWithCompareAtPrice: false,
      isValidPhone: false,
      slides() {
        if (this.modaleType === 'giftBox') {
          return window.__cartConfig.giftBoxSlides;
        } else {
          return window.__cartConfig.eVoucherSlides;
        }
      },
      openModal(modaleType) {
        if (modaleType === 'giftBox') {
          this.modaleType = 'giftBox';
          this.isOpen = true;
          this.currentSlide = 0;
        } else {
          this.modaleType = 'eVoucher';
          this.isOpen = true;
          this.currentSlide = 0;
        }
      },
      closeModal() {
        this.isOpen = false;
        this.modaleType = null;
        this.currentSlide = 0;
      },
      next() {
        this.currentSlide = (this.currentSlide + 1) % this.slides()?.length;
      },
      prev() {
        this.currentSlide = (this.currentSlide - 1 + this.slides()?.length) % this.slides()?.length;
      },
      giftBoxPopupTitle: window.__cartConfig.giftBoxPopupTitle,
      giftBoxPopupDescription: window.__cartConfig.giftBoxPopupDescription,
      eVoucherPopupTitle: window.__cartConfig.eVoucherPopupTitle,
      eVoucherPopupDescription: window.__cartConfig.eVoucherPopupDescription,
      showPackageOption: window.__cartConfig.showPackageOption,
      // The Post card is not rendered when this is off, so Post must never be reachable:
      // giftBoxAvailable() gates every path that could select it or add a box.
      showGiftBoxOption: window.__cartConfig.showGiftBoxOption !== false,
      giftBoxProsuctId: window.__cartConfig.giftBoxProsuctId,
      giftBoxProsuctIdEndpoint: window.__cartConfig.giftBoxProsuctIdEndpoint,
      giftBoxPackagePrice: window.__cartConfig.giftBoxPackagePrice,
      minPhysicalPackageTotalAllowed: window.__cartConfig.minPhysicalPackageTotalAllowed,
      isFirstRuleEngineActivated: window.__cartConfig.isFirstRuleEngineActivated,
      firstRuleEngineMessage: window.__cartConfig.firstRuleEngineMessage,
      secondRuleEngineMessage: window.__cartConfig.secondRuleEngineMessage,
      isSecondRuleEngineActivated: window.__cartConfig.isSecondRuleEngineActivated,
      firstRuleEngine() {
        const cartSubtotalNum = Number((this.cart.original_total_price / 100).toFixed(2));
        const physicalPackageTotalAllowed = Number(Number(this.minPhysicalPackageTotalAllowed).toFixed(2));
        return this.showPackageOption && this.isFirstRuleEngineActivated && (cartSubtotalNum <= physicalPackageTotalAllowed)
      },
      secondRuleEngine() {
        return this.showPackageOption && this.isSecondRuleEngineActivated && Alpine.store('cartStore').isGiftCardInCart
      },
      digitalOnlyRule() {
        return this.showPackageOption && this.isDigitalOnlyProduct === true
      },
      // Is the Post/gift box card on the page at all? Merchant switch, unlike the rule
      // engines below which react to cart contents.
      giftBoxAvailable() {
        return this.showPackageOption && this.showGiftBoxOption
      },
      isTwoRuleEngineActivated() {
        return (this.isFirstRuleEngineActivated && this.firstRuleEngine()) && (this.isSecondRuleEngineActivated && this.secondRuleEngine())
      },
      oneRuleEngineActivated() {
        return (this.isFirstRuleEngineActivated && this.firstRuleEngine()) || (this.isSecondRuleEngineActivated && this.secondRuleEngine()) || this.digitalOnlyRule()
      },
      premiumVariantProductId: null,
      freeVariantProductId: null,
      isPackagedProduct: null,
      isDigitalOnlyProduct: false,
      onEmailChange(e) {
        this.formData.email = e.target.value;
        this.validations.email.required = false
        sessionStorage.setItem('userCartEmail', this.formData.email);
      },
      get isCodeApplied () {
        return Alpine.store('cartStore').isCodeApplied;
      },
      getPromotionForCartItem(item) {
        // B2B customers never see flash-sale promotions (badge/countdown)
        if (this.isB2B) return null;
        if (!item || !item.promotionDataArray || !Array.isArray(item.promotionDataArray)) {
          return null;
        }
        
        // Check if item has "FLASH SALE" discount applied
        const hasFlashSaleDiscount = item.discounts && Array.isArray(item.discounts) &&
          item.discounts.some(discount => discount.title?.toUpperCase() === 'FLASH SALE');

        // GFTY-4391: a non-combinable code (e.g. GET10) DROPS the flash allocation. When that
        // code then LOSES to the flash, the shopper still pays the flash price, so keep showing
        // the badge (not the code tag). ddShowCode is false only when the base won; paired with
        // the flash-only active-promotion check below, that means the flash won. Code-won lines
        // keep ddShowCode true, so they get no badge (their code tag stays).
        const flashWonInTreatment = this.doubleDippingVariant === 'treatment' && !this.ddShowCode(item);
        if (!hasFlashSaleDiscount && !flashWonInTreatment) {
          return null;
        }
        
        // Get valid promotions for this specific item
        // Only require activeFrom - activeTo is optional (can be null)
        const validPromotions = item.promotionDataArray
          .filter(promo => promo?.promotionData?.activeFrom)
          .map(promo => promo.promotionData);
        
        if (validPromotions.length === 0) {
          return null;
        }
        
        // Check if any promotion is currently active
        const now = new Date();
        const activePromotions = validPromotions.filter(promo => {
          const start = new Date(promo.activeFrom);
          const nowTime = now.getTime();
          const startTime = start.getTime();
          
          // If no activeTo, sale is active if current time is after activeFrom
          if (!promo.activeTo) {
            return nowTime >= startTime;
          }
          
          // If activeTo exists, check if sale is between start and end
          const end = new Date(promo.activeTo);
          const endTime = end.getTime();
          return nowTime >= startTime && nowTime < endTime;
        });
        
        if (activePromotions.length === 0) {
          return null;
        }
        
        // Return the promotion ending soonest for this item
        // Prioritize promotions with activeTo over those without
        return activePromotions.reduce((soonest, current) => {
          // If current has no activeTo, prefer the one with activeTo (or keep current if soonest also has no activeTo)
          if (!current.activeTo) {
            return soonest.activeTo ? soonest : current;
          }
          if (!soonest.activeTo) {
            return current;
          }
          return current.activeTo < soonest.activeTo ? current : soonest;
        });
      },
      shouldHideDiscountForItem(item) {
        // Hide discount if item has flash sale promotion and discount code is "FLASH SALE"
        const hasFlashSale = !!this.getPromotionForCartItem(item);
        const discountsData = Alpine.store('cartStore').discountsData;
        const codeTitle = discountsData ? (discountsData.title || discountsData.code) : null;
        const isFlashSaleCode = codeTitle && codeTitle.toUpperCase() === 'FLASH SALE';
        
        return hasFlashSale && isFlashSaleCode;
      },
      maxChars: 300, // Max character limit
      charCount: 0,  // Current character count
      countCharacters(e) {
        this.formData.customMessage = e.target.value;
        this.charCount = this.formData.customMessage?.length;
      },
      // Compute remaining characters
      get remainingChars() {
        return this.maxChars - this.charCount;
      },
      loadingItems: {}, // Object to track loading state for each item
      get ddPriceSettling() {
        return Alpine.store('cartStore').ddPriceSettling; // GFTY-4391: line-price mask
      },
      get cart() {
        return Alpine.store('cartStore').cart; // Access the shared cart store
      },
      get allCartItems() {
        return Alpine.store('cartStore').allCartItems; // Access all items including hidden items
      },
      get isPageLoading() {
        return Alpine.store('cartStore').isPageLoading; // Access shared loading state
      },
      isGiftBoxAdded: false,
      isGiftBoxRemoved: false,
      hiddenItem: [],
      // GFTY-4969: why the gift box could not be reconciled (empty when all is well), plus
      // a compact trail of every gift-box action taken this session. Both ride into the
      // order as `_gft_giftbox_error` / `_gft_giftbox`, so a bad order can be diagnosed
      // from Shopify admin instead of guessed at from additionalProductData.
      giftBoxFailure: '',
      giftBoxTrail: [],
      // GFTY-4969: cart token, kept current by fetchCart()/syncGiftBox() so the buyerIdentity
      // write never has to spend a GET /cart.js to find it. `buyerEmailSyncedKey` is
      // "<cartToken>|<email>" for the last write that succeeded — keyed on both, so a new cart
      // or a corrected email re-syncs rather than silently reusing a stale checkoutUrl.
      cartToken: null,
      buyerEmailSyncedKey: '',
      buyerEmailInFlightKey: '',
      buyerEmailInFlight: null,
      checkoutUrlCache: null,
      _buyerEmailTimer: null,
      // GFTY-4969: serialises every gift-box mutation. Two reconciles running at once each do
      // their own GET /cart.js, so both can see "no box" and both add one — a real race today
      // between removeItemFromCart()'s re-sync and a fast checkout click, and a blocker for
      // adding the box on radio-select rather than at submit.
      _giftBoxQueue: null,
      _giftBoxTimer: null,
      async fetchCart(enableIsLoading = true) {
        if (enableIsLoading) {
          Alpine.store('cartStore').isPageLoading = true; // Update shared loading state
        }
        try {
          const response = await fetch('/cart.js', {
            method: 'GET',
            cache: 'no-store', // This forces the fetch to bypass the cache
          });
          let cart = await response.json();
          // Remove all special products (navidium, service fee) before processing cart data
          const specialItems = cart.items?.filter((item) => item.product_type === 'special' && !item.properties?._hidden_item);
          if (specialItems?.length) {
            const updates = Object.fromEntries(specialItems.map((item) => [item.key, 0]));
            await fetch('/cart/update.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
              },
              body: JSON.stringify({ updates }),
            });
            const updatedResponse = await fetch('/cart.js', { method: 'GET', cache: 'no-store' });
            cart = await updatedResponse.json();
          }
          Alpine.store('cartStore').allCartItems = cart.items; // All items including hidden items
          this.cartToken = cart.token || this.cartToken; // for the buyerIdentity write; see ensureCheckoutEmail

          const isGiftCardInCart = cart.items.some((item) => item.product_type === 'Gift card');

          Alpine.store('cartStore').isGiftCardInCart = isGiftCardInCart;

          // Only find discount codes that are actually applicable
          const cartDiscountCode = Array.isArray(cart.discount_codes) 
            ? cart.discount_codes.find(code => code?.code && code?.applicable !== false) 
            : null;
          const normalizedCartDiscount = cartDiscountCode && cartDiscountCode.applicable !== false
            ? {
                title: cartDiscountCode.code,
                amount: cartDiscountCode.amount,
                type: cartDiscountCode.type,
              }
            : null;
          Alpine.store('cartStore').discountsData = normalizedCartDiscount;

          const variantProductIdSession = sessionStorage.getItem('premiumPackageVariantProductId');

          // Get promotion data from server-side metafields
          const productListWithMetafields = window.__cartItemsWithMetafields;

          const updatedItems = await Promise.all(
            cart.items
              .filter(item =>
                Number(item.variant_id) !== Number(this.premiumVariantProductId) &&
                Number(item.variant_id) !== Number(this.freeVariantProductId)
              ).map(async (item) => {
                const productResponse = await fetch(`/products/${item.handle}.js`);
                const productData = await productResponse.json();
                const variant = productData.variants.find((v) => v.id === item.variant_id);
                if (variant) {
                  item.variant = variant;
                }
                // Add promotion data from server-side metafields
                const productWithMetafields = productListWithMetafields.find(p => p.id === item.id);
                if (productWithMetafields && productWithMetafields.metafields) {
                  item.promotionDataArray = productWithMetafields.metafields.promotion_data || [];
                }
                // Attach raw pricing (from search.variants, exposed as variants_raw_pricing) for the price_on_giftory strikethrough
                if (productWithMetafields) {
                  item.variantsRawPricing = productWithMetafields.variants_raw_pricing || [];
                }
                return item;
              })
          );

          const hiddenItemByVariantId = cart.items.some((item) => {
            return item.variant_id === Number(this.premiumVariantProductId) || item.variant_id === Number(variantProductIdSession);
          });

          const hiddenItemPrice = cart.items.reduce((acc, item) => {
            if (item.variant_id === Number(this.premiumVariantProductId) || item.variant_id === Number(variantProductIdSession)) {
              return acc + item.final_price;
            }
            return acc;
          }, 0);

          const visibleTotal = cart.total_price - hiddenItemPrice;
          const visibleOriginalTotal = cart.original_total_price - hiddenItemPrice;

          const itemsWithCompareAtPrice = updatedItems.filter((item) => item.variant?.compare_at_price);
          const isItemsWithCompareAtPrice = itemsWithCompareAtPrice.length > 0;
          this.isItemsWithCompareAtPrice = isItemsWithCompareAtPrice;

          // "List Price" = Σ the HIGHEST reference price per line (matches the top line strike).
          // That's raw_pricing.display_price (the RRP/display from the metafield) when present,
          // else the variant compare_at — so the total is $140 (display), not $137 (POG, which is
          // what variant.compare_at_price actually holds). Same in both arms.
          // GFTY-4969: derived from the product metafield, not the line-item property — see
          // isPackagedCart(). Drives both the free/premium gift box choice and the free-vs-
          // premium copy in cart-checkout-form.liquid. (Also no longer throws on a line whose
          // `properties` is null, which the old unguarded `item.properties._packaged_product`
          // did — the permalink returns lines with properties stripped.)
          const isPackagedProduct = this.isPackagedCart(updatedItems);
          this.isPackagedProduct = isPackagedProduct;
          this.isDigitalOnlyProduct = this.isDigitalOnlyCart(updatedItems);
          console.log('updatedItems', updatedItems);
          console.log('isPackagedProduct', isPackagedProduct);
          
          // GFTY-4391: "List Price" (beforeAnyDiscount) + "Product discounts" totals — the
          // math lives in DDCart.summary (assets/dd-cart.js). Treatment folds the coupon into
          // ONE List-Price − You-Pay total (Coupon row hidden — see cart-checkout-form.liquid);
          // control keeps the product-discount + FLASH SALE coupon split.
          const youPay = hiddenItemByVariantId ? visibleTotal : cart.total_price;
          const ddSummary = window.DDCart.summary(
            updatedItems, itemsWithCompareAtPrice, window.doubleDippingVariant, youPay
          );
          this.beforeAnyDiscount = ddSummary.beforeAnyDiscount;
          this.productDiscounts = ddSummary.productDiscounts;

          // GFTY-4391: `localStorage.dd_debug='1'` then reload → dump per-line pricing values
          // (compare_at / POG / display / original_price / listCents / showCode) so a wrong
          // tag or strike can be read off directly. No-op unless the flag is set.
          try {
            if (window.localStorage && localStorage.getItem('dd_debug') && window.DDCart && window.DDCart.explain) {
              console.table(updatedItems.map(i => window.DDCart.explain(i, window.doubleDippingVariant)));
            }
          } catch (e) { /* debug only */ }

          const updatedCart = {
            ...cart,
            items: updatedItems,
            // GFTY-5041: the "Coupon discounts" row = DDCart.summary's couponDiscounts, NOT
            // (cart.total_discount − flash). The raw total_discount sums EVERY non-flash
            // allocation, including gross GIFT15 artifacts on base-won lines the transform
            // rebased to POG (money nets back to everyday/flash) — that overstated the row
            // (−$109.14 vs the real −$29.70) and desynced it from Product discounts (which is
            // List − YouPay − couponDiscounts). couponDiscounts counts only code-WON lines
            // (showCode), so both rows now use the same value and reconcile to List − YouPay.
            // In control couponDiscounts == (total_discount − flash), so control is unchanged.
            total_discount: Math.max(0, ddSummary.couponDiscounts),
            total_price: hiddenItemByVariantId ? visibleTotal : cart.total_price,
            original_total_price: hiddenItemByVariantId ? visibleOriginalTotal : cart.original_total_price,
            item_count: updatedItems?.length,
          };

          Alpine.store('cartStore').cart = updatedCart; // Update shared cart data

          // Only set isCodeApplied to true if discount exists, is applicable, and is not FLASH SALE
          if (normalizedCartDiscount && normalizedCartDiscount.title?.toUpperCase() !== 'FLASH SALE') {
            Alpine.store('cartStore').isCodeApplied = true;
          } else {
            // Set to false if no discount, discount is FLASH SALE, or discount is not applicable
            Alpine.store('cartStore').isCodeApplied = false;
          }
        } catch (error) {
          console.error('Error fetching cart data:', error);
        } finally {
          Alpine.store('cartStore').isPageLoading = false; // Reset loading state
          this.cartDataReady = false; // Set to true when fetch completes
        }
      },
      async fetchSingleProductData() {
        if (!this.showPackageOption) return
        try {
          const productResponse = await fetch(`${this.giftBoxProsuctIdEndpoint}${this.giftBoxProsuctId}`);
          const {data} = await productResponse.json();
          const variantOptions = data.product.variants.variantOptions || [];
          // Check if there's a free variant (price = 0)
          const freeVariant = variantOptions.find(variant => Number(variant.price) === 0)?.id
          // If no free variant, find the first premium variant (price > 0)
          const premiumVariant = variantOptions.find(variant => Number(variant.price) > 0)?.id
          const premiumVariantId = premiumVariant?.match(/\d+$/)[0];
          const freeVariantId = freeVariant?.match(/\d+$/)[0];
          this.premiumVariantProductId = premiumVariantId;
          this.freeVariantProductId = freeVariantId;
          console.log('variantOptions', variantOptions);

          sessionStorage.setItem('premiumPackageVariantProductId', premiumVariantId);
          sessionStorage.setItem('freePackageVariantProductId', freeVariantId);
          Alpine.store('cartStore').variantProductId = premiumVariantId;
        } catch (error) {
          console.error('Error fetching product data:', error);
        }
      },
      // GFTY-4969: append to the gift-box audit trail that ships with the order.
      logGiftBox(event) {
        const stamp = new Date().toISOString().slice(11, 19);
        const entry = `${event}@${stamp}`;
        this.giftBoxTrail.push(entry);
        // Keep only the tail — an order attribute is not a log file.
        if (this.giftBoxTrail.length > 12) this.giftBoxTrail.shift();
        // Logged in the same form it takes in the `_gft_giftbox` order attribute, so what
        // you read in DevTools is exactly what you'll find on the order.
        console.log('[giftbox]', entry);
      },
      // GFTY-4969: turn an internal reason code into a sentence someone can act on straight
      // from the order page, without needing docs/gift-box-failure-reasons.md. The raw code
      // is kept in brackets so it still maps back to that reference, and the terse codes stay
      // in the `_gft_giftbox` trail for engineers.
      giftBoxReasonText(reason) {
        const code = String(reason || 'unknown');
        let text;
        if (code.startsWith('no-variant-id')) {
          text = 'The gift box product could not be found, so it was never added to the cart.';
        } else if (code.startsWith('add-failed:add.js 422')) {
          text = 'Shopify refused to add the gift box — usually means it is out of stock.';
        } else if (code.startsWith('add-failed:add.js 429')) {
          text = 'Adding the gift box was rate-limited by Shopify.';
        } else if (code.startsWith('add-failed:add.js 5')) {
          text = 'Shopify had a server error while adding the gift box.';
        } else if (code.startsWith('add-failed')) {
          text = 'The gift box could not be added — the request failed, most likely the shopper lost connection.';
        } else if (code.startsWith('cart-read-failed')) {
          text = 'The cart could not be read, so the gift box could not be added.';
        } else if (code.startsWith('state-mismatch')) {
          text = 'Shopify accepted the gift box but it was not in the cart afterwards.';
        } else if (code.startsWith('remove-failed') || code.startsWith('remove-fallback')) {
          text = 'A leftover gift box from an earlier choice took two attempts to remove. The order is correct — no action needed.';
        } else if (code.startsWith('missing-before-redirect')) {
          text = 'The gift box was in the cart at checkout but disappeared before the order was created.';
        } else {
          text = 'The gift box could not be added, for an unrecognised reason.';
        }
        return `${text} [${code}]`;
      },
      // GFTY-4969: the gift box could not be put in the cart. Rather than block checkout,
      // drop the order back to the self-purchase (e-voucher) flow — buying_for=Self with no
      // send_by — so Shopify never promises a posted gift it has no address for, and stamp
      // the order with the intent plus the reason so ops can spot and follow these up.
      //
      // The `attributes` object is the authoritative target, NOT formData: clearing
      // formData.send_by makes the send_by watcher (checkSentByOption) push buyFor straight
      // back to 'Other' whenever #buying-for-hidden is on the page.
      giftBoxFallbackToSelf(reason, attributes) {
        const detail = String(reason || 'unknown').slice(0, 200);
        this.giftBoxFailure = detail;
        this.logGiftBox(`fallback:self:${detail}`);

        // Capture what the shopper wrote before the Self reset discards it — the order is no
        // longer a gift, so message_to_giftee gets nulled below and would be lost. Ops still
        // has to contact the buyer for an address, and this is the gift message to send on.
        const intendedMsg = attributes.message_to_giftee || this.formData.customMessage || '';
        const intendedRecipient = attributes.gift_sent_to || this.formData.emailGiftFor || '';

        this.formData.buyFor = 'Self';
        this.formData.send_by = '';

        attributes.buying_for = 'Self';
        attributes.send_by = null;
        attributes.gift_sent_to = null;
        attributes.message_to_giftee = null;
        attributes.email_to = null;
        attributes.sent_delivery = null;
        attributes.delivery_date = null;
        // What the shopper actually asked for, and why they didn't get it — written as prose
        // because this is read on the order page by whoever has to put it right.
        attributes._gft_giftbox_failed = 'Post';
        attributes._gft_giftbox_error = `${this.giftBoxReasonText(detail)} The order was placed as a self-purchase e-voucher instead — contact the buyer for a shipping address to post the gift.`.slice(0, 400);
        attributes._gft_giftbox = this.giftBoxTrail.join(';').slice(0, 400);
        // Recovery hints for ops, not storage — truncated.
        if (intendedMsg) attributes._gft_intended_msg = String(intendedMsg).slice(0, 500);
        if (intendedRecipient) attributes._gft_intended_recipient = String(intendedRecipient).slice(0, 100);
      },
      // GFTY-4969: is this a "packaged" cart — one whose product price already includes the
      // gift box, so the FREE gift box variant must be used instead of the $10 premium one?
      //
      // The authoritative source is the product metafield `custom.packaged_product`, emitted
      // server-side per cart item into window.__cartItemsWithMetafields by
      // sections/main-cart-items.liquid. The line-item property `_packaged_product` is only a
      // fallback now: it is written at add-to-cart from a `.packaged-product` DOM attribute, so
      // it is absent whenever the product was added from a template that doesn't render that
      // element, and the checkout permalink strips it on any return to the cart. Either way the
      // cart fell back to the premium variant and charged $10 for a box the shopper had already
      // paid for — orders #739838, #762905 and #771045, with SKU 25273 billed both ways eight
      // days apart. Reading the metafield makes the decision independent of both.
      isPackagedCart(items) {
        const withMetafields = window.__cartItemsWithMetafields || [];
        return (items || []).some((item) => {
          const raw = withMetafields.find((p) => p.id === item.id)?.metafields?.packaged_product;
          // Liquid may serialise a metafield as its bare value or as a {type, value} object.
          const flag = raw && typeof raw === 'object' ? raw.value : raw;
          if (flag === true || flag === 'true') return true;
          return item.properties?._packaged_product === 'true';
        });
      },
      isDigitalOnlyCart(items) {
        const withMetafields = window.__cartItemsWithMetafields || [];
        return (items || []).some((item) => {
          const raw = withMetafields.find((p) => p.id === item.id)?.metafields?.digital_only;
          const flag = raw && typeof raw === 'object' ? raw.value : raw;
          return flag === true || flag === 'true';
        });
      },
      giftBoxLine(items) {
        const premium = Number(this.premiumVariantProductId);
        const free = Number(this.freeVariantProductId);
        return (items || []).find(
          (item) => item.variant_id === premium || item.variant_id === free
        );
      },
      // GFTY-4969: the ONE place that decides whether the gift box belongs in the cart.
      // Reads the LIVE cart rather than Alpine's `allCartItems`, which we confirmed can go
      // stale (store showing 1 item while /cart.js had 4) — that staleness made the old
      // addProductToCart() believe the box was already there and skip the add, leaving
      // send_by=Post orders with no shippable line and therefore no shipping address.
      // Idempotent: safe to call as often as you like.
      // Returns { ok, cart, error } — ok is false whenever the cart ends up in the wrong
      // state, so callers can downgrade the order rather than promise an unpostable gift.
      // Every `error` value is documented in docs/gift-box-failure-reasons.md, with its
      // production cause, resulting order signature, and how to reproduce it.
      // Runs gift-box mutations one at a time, in call order. A rejected op must not poison
      // the chain for everything queued behind it, hence the catch on the stored promise.
      // Does the shopper's current choice call for a gift box? Single source of truth for
      // both the eager reconcile and submitData.
      wantsGiftBox() {
        return this.giftBoxAvailable() && this.formData.buyFor === 'Other' && this.formData.send_by === 'Post';
      },
      // Debounced so flipping Post/Email a few times collapses into one reconcile. The mutex
      // keeps whatever does fire in order, and reconcileGiftBox is idempotent, so a late
      // duplicate is a no-op rather than a second box.
      queueGiftBoxSync() {
        clearTimeout(this._giftBoxTimer);
        this._giftBoxTimer = setTimeout(() => {
          this.syncGiftBox(this.wantsGiftBox()).catch(() => { /* already logged */ });
        }, 250);
      },
      runGiftBoxOp(fn) {
        const next = Promise.resolve(this._giftBoxQueue).catch(() => {}).then(fn);
        this._giftBoxQueue = next.catch(() => {});
        return next;
      },
      // Public entry point — every caller is serialised. The reconcile itself is
      // reconcileGiftBox() below; never call that directly or you lose the ordering guarantee.
      async syncGiftBox(shouldHaveGiftBox) {
        return this.runGiftBoxOp(() => this.reconcileGiftBox(shouldHaveGiftBox));
      },
      async reconcileGiftBox(shouldHaveGiftBox) {
        let cart;
        let cartToken = null;
        try {
          const response = await fetch('/cart.js', { method: 'GET', cache: 'no-store' });
          if (!response.ok) throw new Error(`cart.js ${response.status}`);
          cart = await response.json();
          // Guard the shape too: a proxy or error page returning 200 with a non-cart body
          // would otherwise blow up on cart.items below, outside any try/catch.
          if (!Array.isArray(cart?.items)) throw new Error('cart.js returned no items array');
          // /cart/add.js replies with ONLY { items: [...] } — no token — so re-attach it after
          // each write below. Callers use cart.token to address the Storefront cart without
          // paying for another GET /cart.js.
          cartToken = cart.token;
          this.cartToken = cartToken || this.cartToken;
        } catch (error) {
          console.error('Error reading cart for gift box sync:', error);
          this.logGiftBox('sync:cart-read-failed');
          return { ok: false, cart: null, error: `cart-read-failed:${error.message}` };
        }

        let existing = this.giftBoxLine(cart.items);

        // Derived from the LIVE cart every time, never from this.isPackagedProduct — that
        // flag is computed by fetchCart() and goes stale exactly when it matters:
        // removeItemFromCart() refreshes the cart BEFORE deleting a line, so deleting the
        // packaged product left the flag saying "packaged" and added a FREE box to a cart
        // that now needs the premium one.
        const isPackagedProduct = this.isPackagedCart(cart.items);
        const desiredVariantId = Number(
          isPackagedProduct ? this.freeVariantProductId : this.premiumVariantProductId
        );
        // A box of the WRONG variant is as bad as no box: either the shopper is charged $10
        // for packaging already in the price, or gets a free box they should have paid for.
        // giftBoxLine() matches either variant, so this used to read as "already present"
        // and the wrong box rode through to checkout.
        const wrongVariant = !!existing && !!desiredVariantId && existing.variant_id !== desiredVariantId;

        // Remove first — the box either isn't wanted at all, or is the wrong one and has to
        // go before the right one can be added.
        if (existing && (!shouldHaveGiftBox || wrongVariant)) {
          this.isGiftBoxRemoved = true;
          const removalReason = wrongVariant ? `wrong-variant:${existing.variant_id}` : 'ok';
          try {
            const response = await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: existing.key, quantity: 0 }),
            });
            if (!response.ok) throw new Error(`change.js ${response.status}`);
            cart = await response.json();
            if (cart && !cart.token) cart.token = cartToken;
            existing = null;
            this.logGiftBox(`remove:${removalReason}`);
          } catch (error) {
            console.error('Error removing gift box:', error);
            this.logGiftBox(`remove:failed:${error.message}`);
            return { ok: false, cart, error: `remove-failed:${error.message}` };
          } finally {
            this.isGiftBoxRemoved = false;
          }
        }

        if (shouldHaveGiftBox && !existing) {
          if (!desiredVariantId) {
            // fetchSingleProductData() failed or hasn't run — we cannot add the box at all.
            this.logGiftBox('add:no-variant-id');
            return { ok: false, cart, error: 'no-variant-id' };
          }
          this.isGiftBoxAdded = true;
          try {
            const response = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                items: [{ id: desiredVariantId, quantity: 1, properties: { '_hidden_item': true } }],
              }),
            });
            // A throttled / 422 response used to be swallowed here and the shopper was sent
            // to checkout anyway. Surface it instead.
            if (!response.ok) throw new Error(`add.js ${response.status}`);
            cart = await response.json();
            if (cart && !cart.token) cart.token = cartToken;
            // Record WHICH box was added — a premium box on a packaged product is a $10
            // overcharge, and this makes it visible on the order instead of invisible.
            this.logGiftBox(`add:ok:${isPackagedProduct ? 'free' : 'premium'}`);
          } catch (error) {
            console.error('Error adding gift box:', error);
            this.logGiftBox(`add:failed:${error.message}`);
            return { ok: false, cart, error: `add-failed:${error.message}` };
          } finally {
            this.isGiftBoxAdded = false;
          }
        } else if (shouldHaveGiftBox) {
          this.logGiftBox('add:already-present');
        }

        // add.js and change.js both return the whole cart, so this is authoritative.
        // submitData writes the gift-card line properties off `hiddenItem`; the old code
        // only ever set it inside the add branch, so when the add was skipped nothing was
        // written at all. Consistency only, NOT a functional fix: the checkout permalink
        // rebuilds lines from variant_id:quantity, so every line-item property is discarded
        // before the order exists (verified: zero line attributes on real orders, and
        // `properties: {}` on a post-permalink cart). Giftee delivery runs off the cart
        // ATTRIBUTES via Giftory's voucher backend, which do survive. See the cleanup
        // ticket for removing changeCart entirely.
        this.hiddenItem = cart.items || [];
        Alpine.store('cartStore').allCartItems = cart.items || [];

        // `ok` covers the variant too, not just presence — otherwise a cart left holding the
        // free box when it needs the premium one would report success.
        const finalLine = this.giftBoxLine(cart.items);
        const present = !!finalLine;
        const variantOk = !shouldHaveGiftBox || !desiredVariantId || finalLine?.variant_id === desiredVariantId;
        const ok = present === !!shouldHaveGiftBox && variantOk;
        return {
          ok,
          cart,
          error: ok ? '' : (present && !variantOk ? 'wrong-variant-after-sync' : 'state-mismatch-after-sync'),
        };
      },
      isEmail(email) {
        if (!email || typeof email !== 'string') return false;
        
        // First check for basic pattern
        var re = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        
        // Additional invalid patterns check
        if (email.includes('..') || 
            email.startsWith('.') || 
            email.endsWith('.') ||
            email.indexOf('@') !== email.lastIndexOf('@') || 
            !email.substring(email.indexOf('@')).includes('.') ||
            email.substring(email.indexOf('@')).indexOf('.') === 1) {
          return false;
        }
        
        return re.test(email);
      },
      checkEmail() {
        // Set required error when email field is empty
        if (this.formData.email?.length === 0) {
          this.validations.email.required = true;
        }
      },
      checkCheckbox() {
        // Set 'required' error if checkbox is unchecked
        if (!this.formData.checkbox) {
          this.validations.checkbox.required = true;
        }
      },
      isValid: false,
      isGoToCheckout: false,
      // AB Tasty's tag exposes window.ABTasty once it's finished initializing
      // (https://docs.abtasty.com/client-side/tag/tag-window-abtasty). Read
      // defensively — by checkout submit it's almost always ready, but an
      // adblocker/consent-blocked tag must never break the submit.
      getAbTastyAttrs() {
        try {
          const vid = window?.ABTasty?.visitor?.id || null;
          const history = typeof window?.ABTasty?.getCampaignHistory === 'function'
            ? window?.ABTasty.getCampaignHistory()
            : null;
          return {
            _gft_abtasty_vid: vid,
            _gft_abtasty_campaigns: history && Object.keys(history).length ? JSON.stringify(history) : null,
          };
        } catch (e) {
          return { _gft_abtasty_vid: null, _gft_abtasty_campaigns: null };
        }
      },
      async submitData() {
        const isBuyingForHiddenItem = document.getElementById('buying-for-hidden');

        if (!isBuyingForHiddenItem || isBuyingForHiddenItem === null) {
          await this.checkBuyForOption();
        }
        if (this.showPackageOption) {
          await this.checkSentByOption();
        }
        await this.validateDates();

        // Check for email validation
        if (this.formData.email?.length === 0 || !this.isEmail(this.formData.email)) {
          this.validations.email.required = true;
          this.scrollToElementById('customer-email-id');
          this.isValid = false;
        } else {
          this.validations.email.required = false;
          this.isValid = true;
        }

        // Check for checkbox validation
        if (!this.formData.checkbox) {
          this.validations.checkbox.required = true;
          this.scrollToElementById('email-terms');
          this.isValid = false;
        } else {
          this.validations.checkbox.required = false;
        }

        if (this.formData.buyFor === "Other" && this.formData.send_by === 'Email' && this.formData.emailTo === 'Them' && (!this.formData.emailGiftFor?.length || !this.isEmail(this.formData.emailGiftFor)) ||
        this.formData.buyFor === "Other" && this.formData.emailTo === 'Them' && (!this.formData.emailGiftFor?.length || !this.isEmail(this.formData.emailGiftFor)) && !this.showPackageOption
        ) {
          this.validations.emailGiftFor.required = true;
          this.scrollToElementById('email-gift-for');
          this.isValid = false;
        } else {
          this.validations.emailGiftFor.required = false;
        }

        if (isBuyingForHiddenItem) {
          if (this.formData.send_by_ab?.length === 0 && this.formData.send_by?.length === 0) {
            this.validations.sendBy.required = true;
            this.scrollToElementById('sent-by-error');
            this.isValid = false;
          } else {
            this.validations.sendBy.required = false;
          }
        } else {
          if (!this.formData.buyFor?.length) {
            this.validations.buyFor.required = true;
            this.scrollToElementById('buy-for-error');
            this.isValid = false;
          } else {
            this.validations.buyFor.required = false;
          }
        }
        if (this.formData.buyFor === "Other" && !this.formData.send_by?.length && this.showPackageOption) {
          console.log('here');
          this.validations.sendBy.required = true;
          this.scrollToElementById('sent-by-error');
          this.isValid = false;
        } else {
          this.validations.sendBy.required = false;
        }

        if ((this.formData.buyFor === 'Other' && this.formData.send_by === 'Email' && !this.formData.emailTo?.length && this.showPackageOption) || 
          (this.formData.buyFor === 'Other' && !this.formData.emailTo?.length && !this.showPackageOption)
        ) {
          this.validations.emailTo.required = true;
          this.scrollToElementById('email-to-them');
          this.isValid = false;
        } else {
          this.validations.emailTo.required = false;
        }

        if (this.formData.buyFor === "Other" && this.formData.send_by === 'Email' && this.formData.emailTo === 'Them' && this.formData.dateType === 'future' ||
          this.formData.buyFor === "Other" && this.formData.emailTo === 'Them' && this.formData.dateType === 'future' && !this.showPackageOption
        ) {
          if (!this.formData.selectedYear || !this.formData.selectedMonth || !this.formData.selectedDay || !this.formData.selectedTimeSlot || !this.formData.selectedAmPm || !this.formData.selectedTimeZone) {
            this.validations.selectedYear.required = !this.formData.selectedYear;
            this.validations.selectedMonth.required = !this.formData.selectedMonth;
            this.validations.selectedDay.required = !this.formData.selectedDay;
            this.validations.selectedTimeSlot.required = !this.formData.selectedTimeSlot;
            this.validations.selectedAmPm.required = !this.formData.selectedAmPm;
            this.validations.selectedTimeZone.required = !this.formData.selectedTimeZone;
            this.isValid = false;
          } else {
            this.validations.selectedYear.required = false;
            this.validations.selectedMonth.required = false;
            this.validations.selectedDay.required = false;
            this.validations.selectedTimeSlot.required = false;
            this.validations.selectedAmPm.required = false;
            this.validations.selectedTimeZone.required = false;
          }
        }

        // If any validation fails, do not proceed with the cart update
        console.log('isValid', this.validations);
        if (this.isValid) {
          this.isGoToCheckout = true;
          this.giftBoxFailure = '';

          // GFTY-4969: reconcile the gift box ONCE, here, against the shopper's choice —
          // instead of the old add-here / remove-there / re-add-on-back-nav scatter.
          let wantsGiftBox = this.wantsGiftBox();
          // Captured before the sync so `_gft_store_lag` records how far Alpine's view had
          // drifted from the real cart at the moment the shopper clicked checkout.
          const storeItemCount = (Alpine.store('cartStore').allCartItems || []).length;
          const sync = await this.syncGiftBox(wantsGiftBox);
          const liveItems = sync.cart?.items || this.cart?.items || [];
          const giftBoxLine = this.giftBoxLine(liveItems);
          // Applied after the buying_for branches below, so it overrides the Post attributes.
          const giftBoxFailure = wantsGiftBox && !sync.ok ? sync.error || 'sync-failed' : null;

          // Kick the buyer-identity mutation off NOW and await it just before redirecting.
          // It is a cross-origin Storefront call (~900ms on a cold connection); run last and
          // serially it added that straight onto the shopper's wait. Started here it overlaps
          // the update.js + change.js round trips below and costs nothing on the wall clock.
          // Deliberately after syncGiftBox: the gift box line must already exist, so the
          // checkoutUrl we hand back reflects the final line-up.
          const buyerEmailPromise = this.ensureCheckoutEmail(sync.cart?.token);

          const { selectedYear, selectedMonth, selectedDay, selectedTimeSlot, selectedAmPm, selectedTimeZone } = this.formData;
          const formattedDay = selectedDay?.replace(/(st|nd|rd|th)$/i, '')
          const dateWithZeroIfOneUnit = formattedDay?.length === 1 ? `0${formattedDay}` : formattedDay
          const sentDeliveryDate = `${selectedYear}-${selectedMonth}-${dateWithZeroIfOneUnit}(Time:${selectedTimeSlot}${selectedAmPm} ${selectedTimeZone})`;
          const sentDeliveryDateNoTime = `${selectedYear}-${selectedMonth}-${dateWithZeroIfOneUnit}`;
          const isDeliveryDateValid = selectedYear && selectedMonth && selectedDay
          const timezoneOffset = new Date().getTimezoneOffset();
          let changeCartPayloads = [];
          const variantProductIdSession = sessionStorage.getItem('premiumPackageVariantProductId');

          let updateCartArgs = {
            attributes: {
              customer_email: this.formData.email, // Customer email
              customer_phone: this.isValidPhone ? sessionStorage.getItem('userPhoneInput') : null, // Customer phone
              sms_marketing: this.formData.checkbox, // SMS marketing checkbox
              gift_sent_to: this.formData.emailGiftFor, // Email to send gift card
              buying_for: this.formData.buyFor, // Buying for (Other/Self)
              message_to_giftee: this.formData.customMessage, // Message to giftee
              delivery_date: sentDeliveryDate, // Delivery date
              email_to: this.formData.emailTo, // Gift sent to  (Me/Them) 
              sent_delivery: this.formData.dateType, // Send immediately or future
              send_by: this.formData.send_by, // Send by (Email/Post) (e-vocher or gift box)
              is_packaged_product: this.isPackagedProduct, // Is packaged product
              // GFTY-4969: clear the previous attempt's failure flags on EVERY submit — null
              // deletes the attribute. giftBoxFallbackToSelf() re-sets them below if this
              // attempt fails too. Without this they are sticky: the cart now reaches checkout
              // intact (no permalink rebuild), so a shopper who failed once, went back and
              // succeeded still arrived flagged as downgraded, and the giftbox-fallback-notice
              // extension kept showing "no gift box was added".
              _gft_giftbox_failed: null,
              _gft_giftbox_error: null,
              _gft_intended_msg: null,
              _gft_intended_recipient: null,
              _gft_update_error: null,
              _gft_upd_trace: null,
              _gft_attrs_repaired: null,
              ...this.getAbTastyAttrs(),
            },
            updates: {},
          };

          // Build `updates` from the LIVE cart, not from this.cart — which is sometimes the
          // filtered view and sometimes the raw one depending on which handler wrote it last.
          // The gift box line is deliberately excluded: syncGiftBox owns it, and listing a
          // key it just deleted would fail the whole update.
          liveItems.forEach((item) => {
            if (giftBoxLine && item.key === giftBoxLine.key) return;
            updateCartArgs.updates[item.key] = item.quantity;
          });

          // GFTY-4969 diagnostics — three compact attributes that make a broken order
          // self-explanatory in Shopify admin: what we did to the box, how stale Alpine's
          // view was, and exactly what the cart held at submit time (diff against the
          // order's real lines to catch lines lost after this point).
          updateCartArgs.attributes._gft_giftbox = this.giftBoxTrail.join(';').slice(0, 400);
          updateCartArgs.attributes._gft_store_lag = `store=${storeItemCount};cart=${liveItems.length}`;
          updateCartArgs.attributes._gft_cart_at_submit = liveItems
            .map((item) => `${item.variant_id}:${item.quantity}`)
            .join(',')
            .slice(0, 400);

          if (this.formData.buyFor === 'Self') {
            updateCartArgs.attributes.buying_for = 'Self';
            updateCartArgs.attributes.gift_sent_to = null;
            updateCartArgs.attributes.message_to_giftee = null;
            updateCartArgs.attributes.delivery_date = null; 
            updateCartArgs.attributes.email_to = null;
            updateCartArgs.attributes.sent_delivery = null;
            updateCartArgs.attributes.send_by = null;
          }

          if (this.formData.buyFor === 'Other') {
            if (this.formData.send_by === 'Post') {
              // Gift box already reconciled by syncGiftBox() above.
              updateCartArgs.attributes.buying_for = 'Other';
              updateCartArgs.attributes.send_by = 'Post';
              updateCartArgs.attributes.message_to_giftee = this.formData.customMessage;
              updateCartArgs.attributes.email_to = null
              updateCartArgs.attributes.delivery_date = null;
              updateCartArgs.attributes.gift_sent_to = null;
              updateCartArgs.attributes.sent_delivery = null;
              changeCartPayloads = [];
              // GFTY-4969: the giftee's message belongs on the GIFT BOX line and nowhere else.
              // This used to loop over `this.hiddenItem`, which despite the name is the WHOLE
              // cart (reconcileGiftBox sets it to cart.items) — so every experience product
              // was stamped with a Message it has no use for, and the box was just one line
              // among them. For a posted gift the box is the physical item being shipped and
              // the thing that carries the printed message.
              if (giftBoxLine?.key) {
                changeCartPayloads.push({
                  id: giftBoxLine.key,
                  properties: {
                    '__shopify_send_gift_card_to_recipient': 'On',
                    'Recipient email': null,
                    'Message': this.formData.customMessage ?? null,
                    'Send on': null,
                    '__shopify_offset': null,
                    packaged_product: undefined,
                  },
                });
              }
            } else {
              // Gift box removal is handled by syncGiftBox() at the top of submitData
              if (this.formData.emailTo === 'Me') {
                updateCartArgs.attributes.email_to = 'Me';
                updateCartArgs.attributes.buying_for = 'Other';
                updateCartArgs.attributes.message_to_giftee = this.formData.customMessage;
                updateCartArgs.attributes.send_by = this.showPackageOption ? 'Email' : null;
                updateCartArgs.attributes.delivery_date = null;
                updateCartArgs.attributes.gift_sent_to = null;
                updateCartArgs.attributes.sent_delivery = null;
                for (const element of changeCartPayloads) {
                  element.properties = {
                    '__shopify_send_gift_card_to_recipient': 'On',
                    'Recipient email': this.formData.email,
                    'Message': null,
                    'Send on': null,
                    '__shopify_offset': null,
                    packaged_product: undefined,
                  };
                }
              } else {
                updateCartArgs.attributes.buying_for = 'Other';
                updateCartArgs.attributes.email_to = 'Them'; 
                updateCartArgs.attributes.send_by = this.showPackageOption ? 'Email' : null;
                updateCartArgs.attributes.gift_sent_to = this.formData.emailGiftFor;
                updateCartArgs.attributes.message_to_giftee = this.formData.customMessage;
                if (this.formData.dateType === 'immediately') {
                  updateCartArgs.attributes.sent_delivery = 'immediately';
                  updateCartArgs.attributes.delivery_date = null;
                } else {
                  updateCartArgs.attributes.sent_delivery = 'future';
                  updateCartArgs.attributes.delivery_date = sentDeliveryDate
                }

                if (this.formData.emailGiftFor !== null) {
                  for (const element of changeCartPayloads) {
                    element.properties = {
                      '__shopify_send_gift_card_to_recipient': 'On',
                      'Recipient email': this.formData.emailGiftFor,
                      'Message': null,
                      'Send on': this.formData.dateType === 'future' ? sentDeliveryDateNoTime : null,
                      '__shopify_offset': this.formData.dateType === 'future' ? timezoneOffset : null,
                      packaged_product: undefined,
                    };
                  }
                }
              }
            }
          }

          if (giftBoxFailure) {
            this.giftBoxFallbackToSelf(giftBoxFailure, updateCartArgs.attributes);
            wantsGiftBox = false;
            // The Self flow writes no gift-card recipient properties, so drop the payloads
            // the Post branch queued above.
            changeCartPayloads = [];
          }

          // GFTY-4969, inverse failure: the box is still in the cart for an Email/Self order,
          // i.e. syncGiftBox's removal did not stick. Left alone it ships a physical box for
          // an e-voucher and forces a pointless address step. Drop it in the update.js call
          // that is already going out — the mechanism the pre-fix code used for removals.
          if (!wantsGiftBox && giftBoxLine) {
            updateCartArgs.updates[giftBoxLine.key] = 0;
            this.logGiftBox('remove:via-update-fallback');
            updateCartArgs.attributes._gft_giftbox_error = this.giftBoxReasonText(sync.error || 'remove-fallback');
            updateCartArgs.attributes._gft_giftbox = this.giftBoxTrail.join(';').slice(0, 400);
          }

          // Includes the gift box line, unlike the old this.cart-based version — the
          // changeCart payloads are keyed off the full cart, so a missing entry meant
          // change.js was called with quantity undefined.
          const itemQuantities = {};
          liveItems.forEach((item) => {
            itemQuantities[item.key] = item.quantity;
          });

          let successfullyUpdatedCart = false;
          let updatedCart = null;
          this.isGoToCheckout = true;
          sessionStorage.setItem('cartState', JSON.stringify(updateCartArgs));

          let linePropertyError = null;
          const linePropertyWrites = Promise.all(
            changeCartPayloads.map((payload) =>
              this.changeCart(payload, itemQuantities[payload.id])
            )
          ).catch((error) => { linePropertyError = error; });

          const checkoutUrl = await buyerEmailPromise;

          try {
            updatedCart = await this.updateCart(updateCartArgs);
            successfullyUpdatedCart = true;
          } catch (error) {
            console.error('Error updating cart:', error);
          }

          await linePropertyWrites;
          if (linePropertyError) {
            console.error('Error updating line item property:', linePropertyError);
            // Release the button — this path used to return with isGoToCheckout still true,
            // leaving the shopper on a permanent spinner with no way to retry.
            this.isGoToCheckout = false;
            return;
          }
          if (successfullyUpdatedCart) {
            // GFTY-4969 verification gate: never hand a Post gift to checkout without the
            // gift box line. Without it Shopify sees a digital-only order, never asks for a
            // shipping address, and the gift cannot be posted — 11 orders since January.
            let checkoutCart = updatedCart;
            if (wantsGiftBox && !this.giftBoxLine(checkoutCart.items)) {
              this.logGiftBox('verify:missing-before-redirect');
              const retry = await this.syncGiftBox(true);
              if (retry.ok && retry.cart) {
                checkoutCart = retry.cart;
                this.logGiftBox('verify:recovered');
              } else {
                // Still no box. Don't strand the shopper — send them through as a self
                // purchase, flagged. Patching attributes here is enough: they are what the
                // permalink carries into the order, and it is built below.
                this.giftBoxFallbackToSelf(retry.error || 'missing-before-redirect', updateCartArgs.attributes);
                checkoutCart = retry.cart || checkoutCart;
              }
              // Either branch above changed the trail, and the failure branch also downgraded
              // the order. The CART is what carries attributes into checkout now that there is
              // no permalink query string, so the patched set has to be written back before we
              // redirect — otherwise a late downgrade would exist only in this local object.
              updateCartArgs.attributes._gft_giftbox = this.giftBoxTrail.join(';').slice(0, 400);
              try {
                await this.updateCart({ attributes: updateCartArgs.attributes });
              } catch (e) { console.error('Could not persist gift box outcome:', e); }
            }

            try {
              const live = await fetch('/cart.js', { cache: 'no-store' });
              const liveCart = live.ok ? await live.json().catch(() => null) : null;
              if (liveCart && !liveCart.attributes?.send_by && updateCartArgs.attributes.send_by) {
                console.error('[cart] attributes missing before redirect — rewriting');
                await fetch('/cart/update.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({
                    attributes: {
                      ...updateCartArgs.attributes,
                      _gft_attrs_repaired: new Date().toISOString().slice(11, 19),
                    },
                  }),
                });
              }
            } catch (e) { console.error('[cart] attribute verify failed:', e); }

            // Fire analytics without blocking the checkout redirect (GFTY-4799-2).
            try { pushDataLayerForCheckoutStarted(); } catch (e) { console.error('checkout-started DL error:', e); }
            // Fall through to /checkout when the Storefront call fails: the shopper still
            // checks out with an intact cart, they just type their email again.
            window.location.href = checkoutUrl || '/checkout';
            this.isGoToCheckout = false;
          }
        } else {
          console.log('Form validation failed. Cart update aborted.');
          console.log('this.isValid', this.isValid);
        }
      },
      // Best-effort: returns null on any failure so the caller can still send the shopper to
      // /checkout with an intact cart rather than stranding them.
      // Debounced trigger from the email watcher — the shopper is still typing, so wait for
      // them to stop before spending a request.
      queueCheckoutEmailSync() {
        clearTimeout(this._buyerEmailTimer);
        this._buyerEmailTimer = setTimeout(() => {
          this.ensureCheckoutEmail().catch(() => { /* already logged */ });
        }, 800);
      },
      // Guarantees the cart's buyerIdentity carries the current email, and returns the
      // checkoutUrl to redirect to. Idempotent and cached: called repeatedly while typing and
      // again at submit, but only issues a request when the cart or the email has actually
      // changed. By checkout time the answer is normally already sitting in the cache.
      async ensureCheckoutEmail(token) {
        const email = this.formData.email;
        const cartToken = token || this.cartToken;
        if (!email || !this.isEmail(email) || !cartToken) return this.checkoutUrlCache;

        const key = `${cartToken}|${email}`;
        if (key === this.buyerEmailSyncedKey && this.checkoutUrlCache) return this.checkoutUrlCache;
        // Coalesce: a submit landing mid-prewarm awaits that request instead of racing it.
        if (key === this.buyerEmailInFlightKey && this.buyerEmailInFlight) return this.buyerEmailInFlight;

        this.buyerEmailInFlightKey = key;
        this.buyerEmailInFlight = (async () => {
          const url = await this.setCheckoutBuyerEmail(email, cartToken);
          if (url) {
            this.buyerEmailSyncedKey = key;
            this.checkoutUrlCache = url;
          }
          return url;
        })();
        return this.buyerEmailInFlight;
      },
      async setCheckoutBuyerEmail(email, cartToken, attempt = 0) {
        const token = window.__cartConfig?.storefrontAccessToken;
        const domain = window.__cartConfig?.storeDomain;
        if (!token || !domain) {
          console.error('[checkout] no Storefront credentials in __cartConfig — skipping email prefill');
          return null;
        }
        if (!email) return null;
        try {
          // Callers pass the token from a cart they already hold; only fetch as a fallback.
          // That GET was costing ~290ms on the checkout path for data we already had.
          const cart = cartToken
            ? { token: cartToken }
            : await (await fetch('/cart.js', { cache: 'no-store' })).json();
          if (!cart?.token) throw new Error('no cart token');
          const response = await fetch(`https://${domain}/api/2024-10/graphql.json`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Shopify-Storefront-Access-Token': token,
            },
            body: JSON.stringify({
              query: `mutation($id: ID!, $buyerIdentity: CartBuyerIdentityInput!) {
                cartBuyerIdentityUpdate(cartId: $id, buyerIdentity: $buyerIdentity) {
                  cart { checkoutUrl }
                  userErrors { field message }
                }
              }`,
              variables: {
                id: `gid://shopify/Cart/${cart.token}`,
                buyerIdentity: { email },
              },
            }),
          });
          if (!response.ok) throw new Error(`storefront ${response.status}`);
          const json = await response.json();
          const result = json?.data?.cartBuyerIdentityUpdate;
          if (result?.userErrors?.length) {
            console.error('[checkout] cartBuyerIdentityUpdate userErrors', result.userErrors);
          }
          const url = result?.cart?.checkoutUrl || null;
          console.log('[checkout] email prefill', url ? 'ok' : 'no checkoutUrl returned');
          return url;
        } catch (error) {
          // Observed once in testing: an opaque `TypeError: Failed to fetch` after ~24ms,
          // most likely a throttled Storefront response arriving without CORS headers. It is
          // not reproducible on demand, and losing this call means losing email prefill
          // entirely — so retry once before giving up. The call is started early and overlaps
          // the cart writes, so a second attempt usually still costs nothing.
          console.error('[checkout] email prefill attempt failed, retrying once:', error);
          if (attempt === 0) return this.setCheckoutBuyerEmail(email, cartToken, 1);
          console.error('[checkout] email prefill failed after retry — continuing without it');
          return null;
        }
      },
      async changeCart(formData, currentQuantity) {
        console.log('currentQuantitycurrentQuantity', currentQuantity);
        try {
          const response = await fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              ...formData,
              quantity: currentQuantity,
            }),
          });
          const data = await response.json();
          return data;
        } catch (error) {
          console.error('Error updating line item property: ', error);
          throw error;
        }
      },
      scrollToElementById(elementId) {
        const element = document.getElementById(elementId);
        if (element) {
          window.scrollTo({
            top: element.offsetTop,
            behavior: 'smooth'
          });
        }
      },
      async updateCart(formData) {
        // TEMPORARY (GFTY-4969): trace how far this gets, written as ONE attribute at the end
        // so a broken order shows where it stopped. Remove once the cause is known.
        const trace = [];
        let additionalData;
        try {
          // This additional data is used for Datalayer for checkout
          additionalData = await AttributesForCheckoutDataLayer();
          trace.push(`dl:${JSON.stringify(additionalData ?? '').length}b`);
        } catch (e) {
          trace.push(`dl:threw:${String(e.message).slice(0, 30)}`);
        }
        formData.attributes = {
          ...formData.attributes,
          additionalProductData: additionalData
        };
        trace.push(`body:${JSON.stringify(formData).length}b`);
        trace.push(`attrs:${Object.keys(formData.attributes).length}`);
        trace.push(`updates:${Object.keys(formData.updates || {}).length}`);
        // Rides along in the same payload — no extra request on the checkout path.
        formData.attributes._gft_upd_trace = trace.join(',').slice(0, 180);

        try {
          const response = await fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData),
          });
          if (!response.ok) {
            const body = await response.text().catch(() => '');
            console.error('[cart] update.js failed', response.status, body.slice(0, 200), '— retrying once');

            const retry = await fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(formData),
            });
            if (retry.ok) {
              console.log('[cart] update.js recovered on retry');
              return await retry.json();
            }
            console.error('[cart] update.js failed after retry', retry.status, '— writing minimum attributes');

            // Small payloads still succeed when the full one 422s, so write only what the
            // business needs. send_by matters most: it drives the physical-product tag, which
            // routes to ShipBob. Mitigation, not a fix — the 422 cause is still unknown.
            const essential = {
              customer_email: formData.attributes?.customer_email ?? null,
              buying_for: formData.attributes?.buying_for ?? null,
              message_to_giftee: formData.attributes?.message_to_giftee ?? null,
              send_by: formData.attributes?.send_by ?? null,
              is_packaged_product: formData.attributes?.is_packaged_product ?? null,
              _gft_update_error: `${response.status}/${retry.status} @${new Date().toISOString().slice(11, 19)}`,
              _gft_upd_trace: `${trace.join(',')},retry:${retry.status}`.slice(0, 180),
            };
            try {
              const minimal = await fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ attributes: essential }),
              });
              console[minimal.ok ? 'log' : 'error'](
                '[cart] minimum attributes write', minimal.ok ? 'ok' : `FAILED ${minimal.status}`
              );
            } catch (e) {
              console.error('[cart] minimum attributes write threw', e);
            }
            // Hand back the live cart so submitData can still build the checkout redirect.
            return await (await fetch('/cart.js', { cache: 'no-store' })).json();
          }
          const data = await response.json();
          return data;
        } catch (error) {
          console.error('Update Cart error: ', error);
          throw error;
        }

      },
      async validateDates () {
        if (this.formData.buyFor === 'Other' && this.formData.send_by === 'Email' && this.formData.emailTo === 'Them' && this.dateType === "future" || 
        this.formData.buyFor === 'Other' && this.formData.emailTo === 'Them' && this.dateType === "future" && !this.showPackageOption
        ) {
          if (!this.formData.selectedYear) {
            this.validations.selectedYear.required = true;
          } else {
            this.validations.selectedYear.required = false;
          }
  
          if (!this.formData.selectedMonth) {
            this.validations.selectedMonth.required = true;
          } else {
            this.validations.selectedMonth.required = false;
          }
  
          if (!this.formData.selectedDay) {
            this.validations.selectedDay.required = true;
          } else {
            this.validations.selectedDay.required = false;
          }

          if (!this.formData.selectedYear && !this.formData.selectedMonth && !this.formData.selectedDay) {
            this.validations.date.required = true;
          } else {
            this.validations.date.required = false;
          }
        }
      },
      async removeItemFromCart(itemKey) {
        // Set loading state for all items
        this.cart.items.forEach(item => {
          this.loadingItems[item.key] = true;
        });
        
        await this.fetchCart(false);
        const removedItem = this.cart.items.find((item) => item.id === itemKey.id);
        const selectedItemKey = removedItem?.key;
        // Snapshot the line item before the cart mutates, so remove_from_cart can be
        // published with the same metafield-derived categories view_cart uses. GFTY-5061.
        const removedItemMetafields =
          (window.__cartItemsWithMetafields || []).find((p) => p.id === itemKey.id)?.metafields || {};
        const removedItemCurrency = this.cart?.currency || 'USD';

        try {
          // Remove item from cart via Shopify AJAX API
          const response = await fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({
              id: selectedItemKey,
              quantity: 0, // Set quantity to 0 to remove the item
            }),
          });
          const updatedCart = await response.json();
          this.cart = updatedCart; // Update the cart with new data

          // GFTY-5061: pushDataLayerForRemoveItems existed in dataLayer.js but had no
          // caller, so remove_from_cart never reached GA4. Category resolution mirrors
          // determineCategory4/5 in sections/main-cart-items.liquid.
          if (removedItem && typeof pushDataLayerForRemoveItems === 'function') {
            try {
              const mf = removedItemMetafields;
              const city =
                mf.city ||
                mf.displayed_location ||
                (Array.isArray(mf.location) && mf.location?.[0]?.city) ||
                (Array.isArray(mf.city_tag) && mf.city_tag.length > 1
                  ? 'Multiple cities'
                  : mf.city_tag?.[0]) ||
                '';
              const state =
                mf.state ||
                (Array.isArray(mf.location) && mf.location?.[0]?.state) ||
                (Array.isArray(mf.state_tag) && mf.state_tag?.[0]) ||
                '';
              pushDataLayerForRemoveItems(
                removedItem,
                mf.marketing_category_level1 || '',
                mf.marketing_category_level2 || '',
                mf.marketing_category_level3 || '',
                city,
                state,
                mf.booking_type || '',
                removedItemCurrency
              );
            } catch (e) {
              console.error('remove_from_cart DL error:', e);
            }
          }
          if (this.wantsGiftBox()) {
            // GFTY-4969: was a remove-then-unawaited-re-add pair. The dangling fetch() let
            // the shopper reach checkout mid-flight (box removed, re-add not landed yet),
            // and the free/premium variant was picked from the pre-removal cart. One awaited
            // reconcile instead — the box only ever needs to exist once.
            await this.syncGiftBox(true);
            await this.fetchCart(false);
          }
        } catch (error) {
          console.error('Error removing item from cart:', error);
        } finally {
          this.fetchCart(false); // Fetch the updated cart data
          // Reset loading state for all items
          Object.keys(this.loadingItems).forEach(key => {
            this.loadingItems[key] = false;
          });
        }
      },
      // Only loadSavedCartState() still calls this, for the rule-engine case that forces
      // e-voucher. init() no longer strips the box unconditionally — it reconciles to the
      // restored choice instead (GFTY-4969 S4). Delegates, so there is one implementation.
      async removeGiftBoxFromCart() {
        await this.syncGiftBox(false);
        await this.fetchCart(false);
      },
      // GFTY-4391: the DD display ALGORITHMS live in assets/dd-cart.js (window.DDCart) so
      // they can be read/debugged in isolation; these are thin delegators that pass the AB
      // arm. Templates call ddShowCode(item) / getCartItemStrikePrices(item) unchanged.
      ddShowCode(item) { return window.DDCart.showCode(item, this.doubleDippingVariant); },
      getCartItemStrikePrices(item) { return window.DDCart.strikePrices(item, this.doubleDippingVariant); },
      // True if this line's variant has a double-dipping price (metafield), regardless of the AB arm
      // or whether we display it — used to tag the line with `ddProduct` for experiment scoping.
      itemHasDoubleDip(item) { return window.DDCart.hasDoubleDip(item); },
      formatMoney(amount) {
        const fraction = amount % 100; // Get the cents part
        return new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD',
          minimumFractionDigits: fraction === 0 ? 0 : 2, // Hide decimals if .00
          maximumFractionDigits: 2, // Always show up to 2 decimals if needed
        }).format(amount / 100); // Shopify stores prices in cents
      },
      async checkBuyForOption() {
        // Set 'required' error if no option is selected
        if (!this.formData.buyFor?.length) {
          this.validations.buyFor.required = true;
          this.isValid = false;
        } else {
          this.validations.buyFor.required = false;
          this.isValid = true;
        }
      },
      async checkSentByOption () {
        if (this.formData.buyFor === 'Other') {
          if (!this.formData.send_by?.length) {
            this.validations.sendBy.required = true;
            this.scrollToElementById('sent-by-error');
            this.isValid = false;
          } else {
            this.validations.sendBy.required = false;
          }
        } else {
          const isBuyingForHiddenItem = document.getElementById('buying-for-hidden');
          if (!!isBuyingForHiddenItem && this.formData.send_by_ab?.length === 0) {
            this.formData.buyFor = 'Other';
            this.isValid = true;
          }
        }
      },
      async aBTastyCheckSendByOption() {
        this.formData.send_by_ab = 'ABTastyBuyForSelf';
        this.formData.buyFor = 'Self';
        this.formData.send_by = '';
        this.formData.emailTo = '';
        this.isValid = true;
        console.log('AB Tasty - Auto selected Buying for Self', this.formData);
      },
      updateFuture() {
        if (this.formData.dateType === "future") {
          this.formData.selectedTimeSlot = "09:00";
          this.formData.selectedAmPm = "AM";
          this.formData.selectedTimeZone = "ET";
        }
      },
      async checkEmailToOption() {
        // Validate if emailTo is selected
        if (this.formData.buyFor === "Other" && !this.formData.emailTo?.length) {
          this.validations.emailTo.required = true;
          this.scrollToElementById('email-to-them');
          this.isValid = false;
        } else {
          this.validations.emailTo.required = false;
          this.isValid = true;
        }
      },
      async loadSavedCartState() {
        const savedState = sessionStorage.getItem('cartState');
        if (savedState) {
          const parsedState = JSON.parse(savedState);
          const attributes = parsedState.attributes;
          
          // Restore form data from saved state
          this.formData = {
            email: attributes.customer_email || "",
            phone: attributes.customer_phone || "",
            checkbox: attributes.sms_marketing || true,
            buyFor: attributes.buying_for || "",
            emailTo: attributes.email_to || "",
            emailGiftFor: attributes.gift_sent_to || "",
            dateType: attributes.sent_delivery || "immediately",
            customMessage: attributes.message_to_giftee || "",
            send_by: attributes.send_by || "",
            send_by_ab: attributes.send_by_ab || "",
          };

          // A shopper who picked Post before the option was switched off would otherwise be
          // restored into a choice with no card on the page, leaving the step unselectable.
          if ((this.digitalOnlyRule() || !this.giftBoxAvailable()) && this.formData.send_by === 'Post') {
            this.formData.send_by = 'Email';
            sessionStorage.setItem('cartState', JSON.stringify({
              ...parsedState,
              attributes: { ...attributes, send_by: 'Email' },
            }));
          }

          // Start each cart visit with no gift box; submitData re-adds it if Post is chosen.
          if (this.oneRuleEngineActivated()) {
            await this.removeGiftBoxFromCart();
          }
        }
      },
      saveCartState() {
        const stateToSave = {
          attributes: {
            customer_email: this.formData.email,
            customer_phone: this.formData.phone,
            sms_marketing: this.formData.checkbox,
            gift_sent_to: this.formData.emailGiftFor,
            buying_for: this.formData.buyFor,
            message_to_giftee: this.formData.customMessage,
            email_to: this.formData.emailTo,
            sent_delivery: this.formData.dateType,
            send_by: this.formData.send_by,
            send_by_ab: this.formData.send_by_ab,
          }
        };

        sessionStorage.setItem('cartState', JSON.stringify(stateToSave));
      },
      handleQuantityInput(event, item) {
        const value = parseInt(event.target.value);
        if (!isNaN(value)) {
          const newQuantity = Math.min(Math.max(value, 1), 10);
          if (newQuantity !== item.quantity) {
            this.updateQuantity(item, newQuantity);
          }
        }
      },
      handleQuantityEnter(event, item) {
        event.preventDefault();
        event.stopPropagation();
        const value = parseInt(event.target.value);
        if (!isNaN(value)) {
          const newQuantity = Math.min(Math.max(value, 1), 10);
          if (newQuantity !== item.quantity) {
            this.updateQuantity(item, newQuantity);
          }
        }
        event.target.blur(); // Remove focus from input
      },
      async updateQuantity(item, newQuantity) {
        if (!this.loadingItems) {
          this.loadingItems = {};
        }
        let value = parseInt(event.target.value);
        if (isNaN(value) || value < 1) {
          value = 1;
          event.target.value = 1;
        } else if (value > 10) {
          value = 10;
          event.target.value = 10;
        }
        if (value !== item.quantity) {
          this.updateQuantity(item, value);
        }
      },

      handleQuantityEnter(event, item) {
        event.preventDefault();
        event.stopPropagation();
        let value = parseInt(event.target.value);
        if (isNaN(value) || value < 1) {
          value = 1;
          event.target.value = 1;
        } else if (value > 10) {
          value = 10;
          event.target.value = 10;
        }
        if (value !== item.quantity) {
          this.updateQuantity(item, value);
        }
        event.target.blur(); // Remove focus from input
      },


      async updateQuantity(item, newQuantity) {
        if (!this.loadingItems) {
          this.loadingItems = {};
        }
        
        this.loadingItems[item.key] = true;
        
        try {
          const response = await fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              id: item.key,
              quantity: newQuantity
            })
          });

          if (!response.ok) throw new Error('Network response was not ok');
          
          await this.fetchCart(false);
          
        } catch (error) {
          console.error('Error updating quantity:', error);
        } finally {
          this.loadingItems[item.key] = false;
        }
      },
    };
  }


